import {
  canAccessPortalArea,
  type AuthorizationSubject,
  type PortalCapabilityAction,
} from "@whitehaven/permissions";

export function canAccessAdminCrm(
  subject: AuthorizationSubject | null,
  action: PortalCapabilityAction = "view",
): boolean {
  return (
    subject !== null &&
    (canAccessPortalArea(subject, "admin-crm", action) ||
      canAccessPortalArea(subject, "staff-crm", action))
  );
}

export function adminCrmAuthorizationKey(
  subject: AuthorizationSubject,
): string {
  return JSON.stringify({
    userId: subject.userId,
    roles: [...subject.roles].sort(),
    permissions: [...subject.permissions].sort(),
    locationIds: [...subject.locationIds].sort(),
  });
}
